module.exports = __webpack_public_path__ + "img/chessnut.2a385c7e.png";